"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _reactOverlays = require("react-overlays");
var _parse = _interopRequireDefault(require("date-fns/parse"));
require("./style.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var elementId = 'cccisd-datepicker';
// Add div to the body where we will render the calendar
if (!document.getElementById(elementId)) {
  var div = document.createElement('div');
  div.setAttribute('id', elementId);
  document.body.appendChild(div);
}
var CalendarContainer = function CalendarContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactOverlays.Portal, {
    container: document.getElementById(elementId)
  }, children);
};

/** Show an input field and a calendar which helps to pick the date */
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "getSelected", function () {
      var selected = _this.props.selected;
      var filler = '0000-00-01 12:00:00';
      if (!selected) {
        return null;
      }
      if (typeof selected === 'string') {
        return (0, _parse["default"])(selected + filler.substring(selected.length), 'yyyy-MM-dd HH:mm:ss', new Date());
      }
      return selected;
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dateFormat = _this$props.dateFormat,
        placeholderText = _this$props.placeholderText,
        useDateFormatAsPlaceholder = _this$props.useDateFormatAsPlaceholder;
      var placeholder = placeholderText;
      if (!placeholder && useDateFormatAsPlaceholder && typeof dateFormat === 'string') {
        placeholder = dateFormat;
      }
      return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({}, this.props, {
        selected: this.getSelected(),
        placeholderText: placeholder,
        popperContainer: CalendarContainer
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  /** Class name for the input field */
  className: _propTypes["default"].string,
  /** Date format */
  dateFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  /** Callback when date is selected */
  onChange: _propTypes["default"].func,
  /** Placeholder text */
  placeholderText: _propTypes["default"].string,
  /** Selected value. It has to be Date object */
  selected: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /** Should we use the date format as the placeholder (in the absence of specified placeholderText)? NOTE: this is only used if date format is a string. */
  useDateFormatAsPlaceholder: _propTypes["default"].bool
});
_defineProperty(Component, "defaultProps", {
  className: 'form-control',
  dateFormat: 'MM/dd/yyyy'
});